import Vue from 'vue'
import VeeValidate,{Validator, ValidationProvider, ValidationObserver} from 'vee-validate'
import validatorEs from 'vee-validate/dist/locale/es'

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

Vue.use(VeeValidate, {
    fieldsBagName: 'veeFields'
})
Validator.localize('es', validatorEs);

Validator.extend('rfc', {
    getMessage: field => `El RFC no cumple con las caracteristicas.`,
    validate: value => {
        const strongRegex = new RegExp("^([A-ZÑ&]{3,4}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1]))((-)?(([A-Z]|[a-z]|[0-9]){3}))?$");
        return strongRegex.test(value.toUpperCase());
    }
});
Validator.extend('verify_password', {
    getMessage: field => `La contraseña debe ser mayor a 8 caracteres, contener al menos: 1 mayúscula, 1 minúscula y un número.`,
    validate: value => {
        const strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})");
        return strongRegex.test(value);
    }
});
Validator.extend('numeros_positivos', {
    getMessage: field => `Solo se aceptan números positivos.`,
    validate: value => {
        const strongRegex = new RegExp("^(0*[0-9][0-9]*(\.[0-9]+)?|0+\.[0-9]*[0-9][0-9]*)$");
        return strongRegex.test(value);
    }
});
Validator.extend('comision', {
    getMessage: field => `La comisión debe estar en el rango 1 a 100.`,
    validate: value => {
        const strongRegex = new RegExp("^[1-9][0-9]?$|^100$");
        return strongRegex.test(value);
    }
});
Validator.extend('https', {
    getMessage: field => `La direccion no cumple con las caracteristicas. Debe empezar con https://`,
    validate: value => {
        const strongRegex = new RegExp('^https?:\/\/[A-Za-z0-9\.]*$');
        return strongRegex.test(value);
    }
});
Validator.extend('https_puerto', {
    getMessage: field => `La direccion no cumple con las caracteristicas. Debe empezar con https://`,
    validate: value => {
        const strongRegex = new RegExp('(https?:\/\/[A-Za-z0-9\.]*$)|(https?:\/\/[A-Za-z0-9\.]*(([:]{1}[0-9]{1,5})))$');
        return strongRegex.test(value);
    }
});
Validator.extend('numeros_positivos_sin_cero', {
    getMessage: field => `Solo se aceptan números positivos.`,
    validate: value => {
        const strongRegex = new RegExp("^[1-9][0-9]*$");
        return strongRegex.test(value);
    }
});
Validator.extend('curp', {
    getMessage: field => `La CURP no cumple con las caracteristicas.`,
    validate: value => {
        const strongRegex = new RegExp('^([A-Z&]|[a-z&]{1})([A-Z&]|[a-z&]{1})([A-Z&]|[a-z&]{1})([A-Z&]|[a-z&]{1})([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])([HM]|[hm]{1})([AS|as|BC|bc|BS|bs|CC|cc|CS|cs|CH|ch|CL|cl|CM|cm|DF|df|DG|dg|GT|gt|GR|gr|HG|hg|JC|jc|MC|mc|MN|mn|MS|ms|NT|nt|NL|nl|OC|oc|PL|pl|QT|qt|QR|qr|SP|sp|SL|sl|SR|sr|TC|tc|TS|ts|TL|tl|VZ|vz|YN|yn|ZS|zs|NE|ne]{2})([^A|a|E|e|I|i|O|o|U|u]{1})([^A|a|E|e|I|i|O|o|U|u]{1})([^A|a|E|e|I|i|O|o|U|u]{1})([0-9A-Z]{1}[0-9]{1})$');
        return strongRegex.test(value);
    }
});